<script setup>
import { ref } from 'vue'
import i18n from '../../plugins/i18n'
import { useIncidentStore } from '@/store/incident.js'
import { useToast } from 'vue-toastification'
import GenericCustomDialog from '@/components/GenericCustomDialog.vue'

const props = defineProps({
  incident: { type: Object, default: () => ({}) },
})
const emit = defineEmits(['updateIncident'])

const toast = useToast()
const { t } = i18n.global

const showHideDialog = ref(false)
const showUnhideDialog = ref(false)
const hideReason = ref('')
const loading = ref(false)
const form = ref(null)

async function hideIncident() {
  form.value.validate()
  if (!form.value.isValid) return
  loading.value = true
  const result = await useIncidentStore().hideIncident(props.incident.incidentId, hideReason.value)
  if (result) {
    emit('updateIncident', result)
    showHideDialog.value = false
    toast.success(t('toast.incident.hide.success'))
  } else {
    toast.error(t('toast.incident.hide.error'))
  }
  loading.value = false
}

async function unhideIncident() {
  loading.value = true
  const result = await useIncidentStore().unHideIncident(props.incident.incidentId)
  if (result) {
    emit('updateIncident', result)
    showUnhideDialog.value = false
    toast.success(t('toast.incident.unhide.success'))
  } else {
    toast.error(t('toast.incident.unhide.error'))
  }
  loading.value = false
}
</script>

<template>
  <v-btn
    :prepend-icon="incident.hidden ? 'mdi-eye' : 'mdi-eye-off'"
    :loading="loading"
    variant="tonal"
    @click="incident.hidden ? unhideIncident() : (showHideDialog = true)"
  >
    {{ incident.hidden ? $t('incidents.hidden.operations.unhide') : $t('incidents.hidden.operations.hide') }}
  </v-btn>
  <GenericCustomDialog
    v-model="showHideDialog"
    max-width="800px"
    :card-props="{ loading: loading }"
  >
    <template #headerIcon>
      <v-icon icon="mdi-eye-off" />
    </template>
    <template #title>
      {{ t('incidents.hidden.title') }}
    </template>
    <template #body>
      <v-form ref="form">
        <WYSIWYG
          v-model="hideReason"
          :label="t('incidents.hidden.reason.title')"
          :rules="[v => !!v || 'Reason is required']"
        />
      </v-form>
    </template>
    <template #actions>
      <v-btn
        prepend-icon="mdi-eye-off"
        variant="tonal"
        @click="hideIncident"
      >
        {{ $t('incidents.hidden.operations.hide') }}
      </v-btn>
    </template>
  </GenericCustomDialog>
</template>
